module.exports = __webpack_public_path__ + "static/media/content-navigation.06d555ce.gif";